/*
  SOCHow.js
  Como funciona o SOC Integrado da FMP — fluxo simplificado + CTA.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

const steps = [
  {
    number: "01",
    icon: "sensors",
    title: "Monitoramento contínuo",
    description:
      "Coleta e análise de eventos em tempo real a partir de endpoints, firewalls, SIEM e sistemas legados — mesmo em localidades remotas e isoladas.",
  },
  {
    number: "02",
    icon: "hub",
    title: "Correlação e detecção",
    description:
      "Motor de correlação identifica padrões de ataque e anomalias comportamentais, cruzando dados de múltiplas fontes para reduzir falsos positivos.",
  },
  {
    number: "03",
    icon: "play_circle",
    title: "Resposta automatizada",
    description:
      "Playbooks pré-configurados acionam contenção imediata — isolando o segmento afetado e bloqueando a propagação lateral sem intervenção manual.",
  },
  {
    number: "04",
    icon: "assessment",
    title: "Retenção forense e conformidade",
    description:
      "Logs retidos com rastreabilidade completa para análise forense, auditorias e geração de relatórios de conformidade com LGPD e PCI DSS.",
  },
];

function SOCHow() {
  return (
    <MKBox component="section" py={{ xs: 4, md: 8 }}>
      <Container>

        <Grid container justifyContent="center" mb={6}>
          <Grid item xs={12} md={8} textAlign="center">
            <MKTypography variant="h3" mb={1}>
              Como funciona
            </MKTypography>
            <MKTypography variant="body2" color="text">
              Do monitoramento à conformidade — um fluxo integrado de detecção e resposta,
              desenhado para operar de forma autônoma em ambientes de alta criticidade.
            </MKTypography>
          </Grid>
        </Grid>

        {/* Steps */}
        <Grid container spacing={3} mb={6}>
          {steps.map((step, i) => (
            <Grid item xs={12} sm={6} md={3} key={i}>
              <MKBox textAlign="center" px={1}>
                <MKTypography
                  variant="h2"
                  sx={{ opacity: 0.12, fontWeight: 900, lineHeight: 1, mb: -1 }}
                >
                  {step.number}
                </MKTypography>
                <MKBox
                  width="3rem"
                  height="3rem"
                  variant="gradient"
                  bgColor="info"
                  color="white"
                  coloredShadow="info"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius="xl"
                  mx="auto"
                  mb={2}
                >
                  <Icon fontSize="small">{step.icon}</Icon>
                </MKBox>
                <MKTypography variant="h6" mb={1}>
                  {step.title}
                </MKTypography>
                <MKTypography variant="body2" color="text">
                  {step.description}
                </MKTypography>
              </MKBox>
            </Grid>
          ))}
        </Grid>

        <Divider sx={{ my: 4 }} />

        {/* CTA */}
        <Grid container justifyContent="center">
          <Grid item xs={12} md={8} textAlign="center">
            <MKTypography variant="h4" mb={1}>
              Pronto para proteger suas operações?
            </MKTypography>
            <MKTypography variant="body2" color="text" mb={3}>
              Fale com um especialista da FMP Soluções para entender como o SOC Integrado
              se adapta à sua infraestrutura e requisitos regulatórios.
            </MKTypography>
            <MKButton
              variant="gradient"
              color="info"
              size="large"
              component="a"
              href="/pages/ajuda/contate-nos"
            >
              Solicitar avaliação gratuita
            </MKButton>
          </Grid>
        </Grid>

      </Container>
    </MKBox>
  );
}

export default SOCHow;
